<template>
  <div>
    <div class="tw-items-center tw-px-2 tw-bg-white tw-shadow-md tw-pt-3.5 tw-h-auto">
      <p class="tw-text-sm tw-px-2 tw-leading-14px tw-font-medium tw-h-18px">Treatment</p>

      <div class="tw-w-full parent">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
            :class="howPlayerInjured !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >How was the player injured?</label
          >

          <select
            id="howPlayerInjured"
            ref="howPlayerInjured"
            class="tw-w-full tw-text-sm tw-pt-0 tw-pb-2 tw-px-2 tw--mt-5px tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none"
            v-model="howPlayerInjured"
            placeholder="How was the player injured?"
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && howPlayerInjured === undefined,
              },
              howPlayerInjured !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
          >
            <option value="undefined" :disabled="true">How was the player injured?</option>
            <option v-for="item in howPlayerInjuredList" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <Transition name="other">
        <div class="tw-w-full parent" v-show="howPlayerInjured === 'Other'">
          <div class="child">
            <input
              id="howPlayerInjuredOther"
              ref="howPlayerInjuredOther"
              class="input tw-pt-2.5 tw-px-2 tw-pb-2"
              :class="[
                {
                  ' tw-plceholder-red-600  ': submitted && !howPlayerInjuredOther,
                },
                howPlayerInjuredOther
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-gray-1010',
              ]"
              autocomplete="off"
              v-model="howPlayerInjuredOther"
              placeholder="Please describe how the player was injured"
            />
          </div></div
      ></Transition>
      <div class="tw-w-full parent">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
            :class="playerRemoveBy !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >How was the player removed from the field?</label
          >

          <select
            id="playerRemoveBy"
            ref="playerRemoveBy"
            class="tw-w-full tw-text-sm tw-pt-0 tw-pb-2 tw-px-2 tw--mt-5px tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none"
            v-model="playerRemoveBy"
            placeholder="How was the player removed from the field?"
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && playerRemoveBy === undefined,
              },
              playerRemoveBy !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
          >
            <option value="undefined" :disabled="true">
              How was the player removed from the field?
            </option>
            <option v-for="item in playerRemoveList" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <div class="tw-w-full parent">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-flex-wrap tw-mb-2.5"
            :class="treatPlayer !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >Was an ambulance or doctor called to treat the player?</label
          >

          <select
            id="treatPlayer"
            ref="treatPlayer"
            class="tw-w-full tw-text-sm tw-flex tw-pt-0 tw-pb-2 tw-px-2 tw-whitespace-pre-wrap tw--mt-5px tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none"
            v-model="treatPlayer"
            placeholder=""
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && treatPlayer === undefined,
              },
              treatPlayer !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
            @change="playerReferredTo = undefined"
          >
            <option value="undefined" :disabled="true" style="word-wrap: break-word">
              Was an ambulance or doctor called to treat the player?
            </option>
            <option v-for="item in yesOrNo" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <div class="tw-w-full parent" v-show="treatPlayer === true">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
            :class="playerReferredTo !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >Who was the player referred to?</label
          >

          <select
            id="playerReferredTo"
            rfe="playerReferredTo"
            class="tw-w-full tw-text-sm tw-pt-0 tw-pb-2 tw-px-2 tw--mt-5px tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none"
            v-model="playerReferredTo"
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && playerReferredTo === undefined,
              },
              playerReferredTo !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
            placeholder=""
          >
            <option value="undefined" :disabled="true">Who was the player referred to?</option>
            <option v-for="item in playerRefferedList" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <Transition name="other">
        <div class="tw-w-full parent" v-show="playerReferredTo === 'Other'">
          <div class="child">
            <input
              id="playerReferredToOther"
              ref="playerReferredToOther"
              class="input tw-px-2 tw-pb-2 tw-pt-2.5"
              :class="[
                {
                  ' tw-placeholder-red-600': submitted && !playerReferredToOther,
                },
                playerReferredToOther
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-gray-1010',
              ]"
              autocomplete="off"
              v-model="playerReferredToOther"
              placeholder="Please describe who the player was referred to"
            />
          </div>
        </div>
      </Transition>
      <div class="tw-w-full parent">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
            :class="immediateCare !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >What was the immediate care applied to the injury?</label
          >

          <select
            id="immediateCare"
            ref="immediateCare"
            class="tw-w-full tw-text-sm tw-pt-0 tw-pb-2 tw-px-2 tw-whitespace-pre-wrap tw--mt-5px tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none"
            v-model="immediateCare"
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && immediateCare === undefined,
              },
              immediateCare !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
            placeholder=""
          >
            <option value="undefined" :disabled="true">
              What was the immediate care applied to the injury?
            </option>
            <option v-for="item in immediateCareList" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <Transition name="other">
        <div class="tw-w-full parent" v-show="immediateCare === 'Other'">
          <div class="child">
            <input
              id="immediateCareOther"
              rfe="immediateCareOther"
              class="input tw-pt-2.5 tw-px-2 tw-pb-2"
              :class="[
                { ' tw-placeholder-red-600 ': submitted && !immediateCareOther },
                immediateCareOther
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-gray-1010',
              ]"
              autocomplete="off"
              v-model="immediateCareOther"
              placeholder="Please describe the treatment"
            />
          </div>
        </div>
      </Transition>
      <div class="tw-w-full tw-mb-0">
        <label
          class="tw-flex tw-justify-between tw-px-2 tw-pb-2 tw-text-sm tw-font-normal tw-leading-4 tw-text-black tw-pt-4"
          >First Responder Name</label
        >
        <textarea
          id="firstResponderName"
          v-model="firstResponderName"
          class="textBox tw-p-2"
          maxlength="50"
          :class="firstResponderName !== '' ? 'tw-font-medium' : 'tw-font-normal'"
        ></textarea>
      </div>
      <div class="tw-w-full parent tw--mt-2">
        <div class="child">
          <label
            class="tw-text-10px tw-px-2 tw-leading-10px tw-font-normal tw-pt-2.5 tw-flex tw-justify-between tw-mb-2.5"
            :class="firstResponderRole !== undefined ? 'tw-text-gray-1020' : 'tw-text-white'"
            >First responder Role</label
          >

          <select
            id="firstResponderRole"
            v-model="firstResponderRole"
            class="tw-w-full tw-px-2 tw-pt-0 tw-whitespace-pre-wrap tw-pb-2 tw-text-sm tw-text-black tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw--mt-5px"
            :class="[
              {
                ' tw-placeholder-red-600 select_error tw-text-red-600':
                  submitted && firstResponderRole === undefined,
              },
              firstResponderRole !== undefined ? 'tw-font-medium' : 'tw-font-normal',
            ]"
            placeholder=""
          >
            <option value="undefined" :disabled="true">First responder Role</option>
            <option v-for="item in firstResponderRoleList" :key="item.option" :value="item.value">
              {{ item.option }}
            </option>
          </select>
        </div>
      </div>
      <div class="tw-w-full">
        <label
          class="tw-text-sm tw-px-2 tw-leading-4 tw-pb-2 tw-font-normal tw-pt-7 tw-flex tw-justify-between tw-text-black"
          >Any significant observations.</label
        >

        <textarea
          id="otherSignificants"
          class="tw-h-20 textBox tw-pt-2.5 tw-mb-27px"
          v-model="otherSignificants"
          resize="none"
          rows="5"
        ></textarea>
      </div>
    </div>
    <div class="tw-mt-8 sm:tw-flex sm:tw-justify-center">
      <button
        class="tw-justify-center tw-w-full tw-mb-4 sm:tw-mr-4 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
        type="success"
        size="medium"
        :disabled="isSaving"
        @click="nextMove"
      >
        Complete
      </button>

      <button
        class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-bg-none tw-border-2 tw-border-green-700 hover:tw-border-green-300 hover:tw-text-black sm:tw-w-72"
        type=""
        size="medium"
        :disabled="isSavingDraft"
        @click="saveLater"
      >
        Save Draft
      </button>
    </div>
  </div>
</template>

<script>
import {
  injuryNatureList,
  playerRemoveList,
  howPlayerInjuredList,
  playerRefferedList,
  immediateCareList,
  firstResponderRoleList,
  yesOrNo,
  roles,
} from "../../utils/constants";

export default {
  props: ["injury", "members"],
  data() {
    return {
      yesOrNo,
      injuryNatureList,
      howPlayerInjuredList,
      playerRemoveList,
      playerRefferedList,
      immediateCareList,
      firstResponderRoleList,
      howPlayerInjured: undefined,
      howPlayerInjuredOther: "",
      playerRemoveBy: undefined,
      treatPlayer: undefined,
      playerReferredTo: undefined,
      playerReferredToOther: "",
      immediateCare: undefined,
      immediateCareOther: "",
      firstResponderName: "",
      firstResponderRole: undefined,
      otherSignificants: "",
      submitted: false,
      moveToNextStep: false,
      isSaving: false,
      isSavingDraft: false,
      roles,
    };
  },
  mounted() {
    if (this.injury?.playerRemoveBy) this.playerRemoveBy = this.injury.playerRemoveBy;
    this.treatPlayer = this.injury.treatPlayer;
    this.playerReferredTo = this.injury.playerReferredTo;
    if (this.injury?.playerReferredToOther)
      this.playerReferredToOther = this.injury.playerReferredToOther;
    if (this.injury?.immediateCare) this.immediateCare = this.injury.immediateCare;
    if (this.injury?.immediateCareOther) this.immediateCareOther = this.injury.immediateCareOther;
    if (this.injury?.firstResponderName) this.firstResponderName = this.injury.firstResponderName;
    if (this.injury?.firstResponderRole) this.firstResponderRole = this.injury.firstResponderRole;
    if (this.injury?.otherSignificants) this.otherSignificants = this.injury.otherSignificants;
    if (this.injury?.howPlayerInjured) this.howPlayerInjured = this.injury.howPlayerInjured;
    if (this.injury?.howPlayerInjuredOther)
      this.howPlayerInjuredOther = this.injury.howPlayerInjuredOther;
    if (this.injury?.member?._id)
      this.injury.member.name = this.members.find((x) => x._id === this.injury.member._id).name;
  },
  methods: {
    scrollToElement(refName) {
      var element = document.getElementById(refName);
      element.scrollIntoView({ block: "center" });
    },
    async nextMove() {
      this.submitted = true;
      // this.$store.commit("root/loading", true);
      this.injury.playerRemoveBy = this.playerRemoveBy;
      this.injury.treatPlayer = this.treatPlayer;
      this.injury.playerReferredTo = this.playerReferredTo;
      this.injury.playerReferredToOther = this.playerReferredToOther;
      this.injury.immediateCare = this.immediateCare;
      this.injury.immediateCareOther = this.immediateCareOther;
      this.injury.firstResponderName = this.firstResponderName;
      this.injury.firstResponderRole = this.firstResponderRole;
      this.injury.otherSignificants = this.otherSignificants;
      this.injury.howPlayerInjured = this.howPlayerInjured;
      this.injury.howPlayerInjuredOther = this.howPlayerInjuredOther;

      // if (
      //   this.injury.playerRemoveBy === undefined ||
      //   this.injury.treatPlayer === undefined ||
      //   this.injury.immediateCare === undefined
      // ) {
      //   return;
      // }

      // if (this.injury.treatPlayer === true && !this.injury.playerReferredTo) {
      //   return;
      // }
      // if (this.injury.playerReferredTo === "Other" && !this.injury.playerReferredToOther) {
      //   return;
      // }
      // if (this.injury.immediateCare === "Other" && !this.injury.immediateCareOther) {
      //   return;
      // }

      // If any of injury is not filled
      // const injuryNotFilled = this.injury.natureOfInjury.find(item => item.injury === undefined);
      // if (injuryNotFilled) return;
      // If Body Part is filled and nature of injury is empty => return and show error
      // const injuryNotFilled = this.injury.natureOfInjury.find(
      //   item => item.bodyArea && item.bodyPart && item.injury === undefined
      // );
      // if (injuryNotFilled !== undefined) {
      //   return;
      // }

      // //If the injury is Head/face/Neck and symptoms are not marked
      // if (this.headIsExits && this.injury.symptons === undefined) return;

      // if (this.injury.howPlayerInjured === undefined) return;
      // if (this.injury.howPlayerInjured === "Other" && this.injury.howPlayerInjuredOther === "")
      //   return;

      if (this.injury.howPlayerInjured === undefined) {
        this.scrollToElement("howPlayerInjured");
        return;
      }
      if (this.injury.howPlayerInjured === "Other" && this.injury.howPlayerInjuredOther === "") {
        this.scrollToElement("howPlayerInjuredOther");
        return;
      }

      //If the injury is Head/face/Neck and symptoms are not marked
      if (this.headIsExits && this.injury.symptons === undefined) {
        this.scrollToElement("symptons");
        return;
      }

      if (this.injury.playerRemoveBy === undefined) {
        this.scrollToElement("playerRemoveBy");
        return;
      }
      if (this.injury.treatPlayer === undefined) {
        this.scrollToElement("treatPlayer");
        return;
      }

      if (this.injury.treatPlayer === true && this.injury.playerReferredTo === undefined) {
        this.scrollToElement("playerReferredTo");
        return;
      }
      if (this.injury.immediateCare === undefined) {
        this.scrollToElement("immediateCare");
        return;
      }

      if (this.injury.firstResponderName === undefined) {
        this.scrollToElement("firstResponderName");
        return;
      }

      if (this.injury.firstResponderRole === undefined) {
        this.scrollToElement("firstResponderRole");
        return;
      }

      if (this.injury.treatPlayer === true && !this.injury.playerReferredTo) {
        return;
      }
      if (this.injury.playerReferredTo === "Other" && !this.injury.playerReferredToOther) {
        return;
      }
      if (this.injury.immediateCare === "Other" && !this.injury.immediateCareOther) {
        return;
      }

      if (this.injury.natureOfInjury.length <= 0) { return this.$customError("Could not submit please check entered data"); }

      this.injury.status = "Completed";

      if (this.injury?.member?._id) { this.injury.member.name = this.members.find(x => x._id === this.injury.member._id).name; }

      const injuryDateToUpdate = this.dayjs(this.injury.dateOfInjuryStr).valueOf();

      const dt = new Date(`${this.injury.dateOfInjuryStr} ${this.injury.timeOfInjuryStr}`);
      const injuryTimeToUpdate = dt.getTime();

      this.injury.dateOfInjury = injuryDateToUpdate || undefined;
      this.injury.timeOfInjury = injuryTimeToUpdate || undefined;
      this.isSaving = true;
      if (this.injury._id) {
        await this.$http
          .put(`/nrl/api/v1/admin/injury-cases/${this.injury._id}`, this.injury)
          .then((res) => {
            const fromTreatmentPage = true;
            this.$emit("redirectFromTreatment", this.injury, fromTreatmentPage);
            this.submitted = false;
            this.isSaving = false;
            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
            this.$customError();
            this.isSaving = false;
            this.submitted = false;
          });
      } else {
        try {
          const res = await this.$http.post("/nrl/api/v1/admin/injury-cases", this.injury);
          this.injury._id = res.data.data;
          this.submitted = false;
          this.isSaving = false;
          const fromTreatmentPage = true;
          this.$emit("redirectFromTreatment", this.injury, fromTreatmentPage);
          this.$store.commit("root/loading", false);
        } catch (e) {
          this.submitted = false;
          this.isSaving = false;
          this.$store.commit("root/loading", false);
          this.$customError();
          return;
        }
      }
      return;
    },
    async saveLater() {
      this.$store.commit("root/loading", true);
      this.injury.playerRemoveBy = this.playerRemoveBy;
      this.injury.treatPlayer = this.treatPlayer;
      this.injury.playerReferredTo = this.playerReferredTo;
      this.injury.playerReferredToOther = this.playerReferredToOther;
      this.injury.immediateCare = this.immediateCare;
      this.injury.immediateCareOther = this.immediateCareOther;

      this.injury.firstResponderName = this.firstResponderName;
      this.injury.firstResponderRole = this.firstResponderRole;
      this.injury.otherSignificants = this.otherSignificants;
      this.injury.howPlayerInjured = this.howPlayerInjured;
      this.injury.howPlayerInjuredOther = this.howPlayerInjuredOther;

      const injuryDateToUpdate = this.dayjs(this.injury.dateOfInjuryStr).valueOf();

      const dt = new Date(`${this.injury.dateOfInjuryStr} ${this.injury.timeOfInjuryStr}`);
      const injuryTimeToUpdate = dt.getTime();

      this.injury.dateOfInjury = injuryDateToUpdate || undefined;
      this.injury.timeOfInjury = injuryTimeToUpdate || undefined;

      if (this.injury?.member?._id) { this.injury.member.name = this.members.find(x => x._id === this.injury.member._id).name; }

      this.isSavingDraft = true;

      if (this.activeRoleType === this.roles.gamedayAdmin && this.injury) {
        if (this.injury.meta) this.injury.meta = { ...this.injury.meta, gameDayAdmin: true };
        else {
          this.injury.meta = {};
          this.injury.meta.gameDayAdmin = true;
        }
      }

      if (this.injury._id) {
        await this.$http
          .put(`/nrl/api/v1/admin/injury-cases/${this.injury._id}`, this.injury)
          .then((res) => {
            const fromTreatmentPage = true;
            const save = true;
            this.$emit("redirectFromTreatment", this.injury, fromTreatmentPage, save);
            this.submitted = false;
            this.isSavingDraft = false;
            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
            this.$customError();
            this.isSavingDraft = false;
            this.submitted = false;
          });
      } else {
        await this.$http
          .post("/nrl/api/v1/admin/injury-cases", this.injury)
          .then((res) => {
            this.injury._id = res.data.data;
            const fromTreatmentPage = true;
            this.isSavingDraft = false;
            const save = true;
            this.$emit("redirectFromTreatment", this.injury, fromTreatmentPage, save);
            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.isSavingDraft = false;
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      }
    },
  },
  computed: {
    activeRoleType() {
      return this.$store.getters["user/activeRole"].type;
    },
    isComplete() {
      let formFilled = false;
      if (
        this.howPlayerInjured != undefined &&
        this.playerRemoveBy != undefined &&
        this.treatPlayer != undefined &&
        this.immediateCare != undefined
      ) {
        formFilled = true;
        if (this.treatPlayer) {
          if (this.playerReferredTo != undefined) {
            if (this.playerReferredTo === "Other") {
              formFilled = this.playerReferredToOther != "" ? true : false;
            }
          } else {
            formFilled = false;
          }
        }

        if (this.howPlayerInjured === "Other") {
          formFilled = this.howPlayerInjuredOther != "" ? true : false;
        }
        if (this.immediateCare === "Other") {
          formFilled = this.immediateCareOther != "" ? true : false;
        }
      }
      return formFilled;
    },
  },
};
</script>

<style scoped>
.other-enter-active,
.other-leave-active {
  transition: all 0.6s ease-in-out;
}

.other-enter,
.other-leave-to {
  opacity: 0;
}
</style>
